import ReactMarkdown from 'react-markdown';
import styles from './ChatSidebar.module.scss';

export const Message = ({ message }) => {
	const isUser = message.role === 'user';
	const isError = message.isError;

	return (
		<div className={`${styles.message} ${isUser ? styles.messageUser : styles.messageAssistant} ${isError ? styles.messageError : ''}`}>
			<div className={styles.messageContent}>{isUser ? message.content : <ReactMarkdown>{message.content}</ReactMarkdown>}</div>
		</div>
	);
};
